import { ResourceBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { adminDomainBuilder } from './__generated/admin-implementation.js';
import { generatedConfiguratorBuilder } from './__generated/configurator-builder.js';
import { domainBuilder, invariantBuilder } from './__generated/implementation.js';
import { migrateAdmin } from './admin-migrations/index.js';
import { legsExpressions, legsInvariants } from './implementation/legs.js';
import { tableExpressions } from './implementation/table.js';
import { topCircleExpressions } from './implementation/top-circle.js';
import { topDanishOvalExpressions } from './implementation/top-danish-oval.js';
import { topHalfCircleExpressions } from './implementation/top-half-circle.js';
import { topHalfOvalExpressions } from './implementation/top-half-oval.js';
import { topOvalExpressions } from './implementation/top-oval.js';
import { topRectangleExpressions } from './implementation/top-rectangle.js';
import { topWithLengthAndWidthExpressions } from './implementation/top-with-length-and-width.js';
import { topExpressions, topInvariants } from './implementation/top.js';
import { migrate } from './migrations/index.js';
const violationExpressions = invariantBuilder.withInvariants(legsInvariants).withInvariants(topInvariants).buildViolationExpressions();
const domainFactory = domainBuilder.withExpressions(violationExpressions).withExpressions(tableExpressions).withExpressions(legsExpressions).withExpressions(topExpressions).withExpressions(topCircleExpressions).withExpressions(topDanishOvalExpressions).withExpressions(topHalfCircleExpressions).withExpressions(topHalfOvalExpressions).withExpressions(topOvalExpressions).withExpressions(topRectangleExpressions).withExpressions(topWithLengthAndWidthExpressions).withMigrate(migrate).build();
const adminDomainFactory = adminDomainBuilder.withMigrate(migrateAdmin).build();
export const resources = new ResourceBuilder().addClientGeneratedImage({
    type: 'Image',
    name: 'thumbnail',
    s3Key: 'thumbnail',
    clientGenerated: true
}).build();
export const configuratorBuilder = generatedConfiguratorBuilder.withDomainFactory(domainFactory).withAdminDomainFactory(adminDomainFactory).withResources(resources);
export * as AdminEnhancedDomain from './__generated/admin-enhanced-model.js';
export * as AdminModel from './__generated/admin-model/index.js';
export * as ApplicationTypes from './__generated/application-types.js';
export * as EnhancedDomain from './__generated/enhanced-model.js';
export * as Model from './__generated/model/index.js';
export { attachAdminComponent, createAdminRecipe } from './__generated/admin-implementation.js';
export { attachComponent, createRecipe } from './__generated/implementation.js';
export { createPresets } from './__generated/presets.js';
export { Textures } from './data/materials.js';
export { TopColorFenixSwatchMap, ColorOakSwatchMap, TopColorCeramicSwatchMap, SteelLegsSwatchMap } from './data/swatches.js';
export { resolveProductDescription } from './product-description.js';

//# sourceMappingURL=index.js.map